import { adapterClientDateFormat } from '../adapters/adapterClientDateFormat';
import InsuranceService from '../services/InsuranceService';
import { types } from '../types/types';
import { addNotificationError } from './notificationAction';
import { setIsCalculating } from './offerAction';

const adaptClientForInsuranceRequest = (client, includeTomadorFields = false) => {
  const adaptedClient = {
    ...adapterClientDateFormat({ ...client }),
  };

  if (!includeTomadorFields) {
    delete adaptedClient.FechaEfecto;
    delete adaptedClient.Nacionality;
  }

  return adaptedClient;
};

export const GetTarificacionZurichLongDrive = () => {
  return async (dispatch, getState) => {
    dispatch(setIsCalculating(true));
    const { selectedSeguroAutoStandAlone } = getState().summary;

    const request = [
      adaptClientForInsuranceRequest(selectedSeguroAutoStandAlone.Tomador, true),
      adaptClientForInsuranceRequest(selectedSeguroAutoStandAlone.ConductorHabitual),
    ];

    const conductorOcasional = selectedSeguroAutoStandAlone.CondutorOcasional;

    if (conductorOcasional?.NIF?.trim()) {
      request.push(adaptClientForInsuranceRequest(conductorOcasional));
    }

    var insuranceService = new InsuranceService();
    const { data, status, errors } = await insuranceService.getAutoInsuranceStandAloneLDTarificacion(request);

    dispatch(setIsCalculating(false));

    if (status === 200) {
      dispatch(setTarificacionZurich(data));
      return true;
    }

    dispatch(setTarificacionZurich(errors));

    if (errors[0].internalValue !== 'No existen aportaciones para el paquete actual') {
      dispatch(addNotificationError(errors));
    }

    return false;
  };
};

export const setTarificacionZurich = (payload) => ({
  type: types.insuranceSetTarifasZurich,
  payload,
});

export const setSeguroStandAlone = (Tomador, ConductorHabitual, ConductorOcasional, seguro) => {
  const tomador = {
    ...Tomador,
    ClaveRol: 'TOM',
  };
  const conductorHabitual = {
    ...ConductorHabitual,
    ClaveRol: 'COH',
    FechaEfecto: Tomador.FechaEfecto,
  };
  const conductorOcasional = ConductorOcasional
    ? {
        ...ConductorOcasional,
        ClaveRol: 'CO2',
        FechaEfecto: Tomador.FechaEfecto,
      }
    : null;
  return {
    Tomador: tomador,
    ConductorHabitual: conductorHabitual,
    CondutorOcasional: conductorOcasional,
    SeguroContratado: seguro,
  };
};
